import { getSerializedCustomer, RawSessionCustomer, SessionCustomer } from '@cld/session-service';

interface ExtendedRawSessionCustomer extends RawSessionCustomer {
  status?: string;
}
interface ExtendedSessionCustomer extends SessionCustomer {
  status?: string;
}

export const getSerializedCustomersList = (customersList: ExtendedRawSessionCustomer[]): ExtendedSessionCustomer[] =>
  customersList.map((customer) => {
    const serializedCustomer = getSerializedCustomer(customer) as ExtendedSessionCustomer;
    if (customer.status) {
      return { ...serializedCustomer, status: customer.status };
    }
    return serializedCustomer;
  });
